module.exports = __webpack_public_path__ + "hollard-logo.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/hollard-logo.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/hollard-logo.png
// module chunks = 10